// Row labels for the Netflix layout
export const NETFLIX_ROWS = [
  'Selected Work',
  'Promos and Highlights',
  'Brand & Live',
  'Booth & Activation',
  'Small Events',
];

export const ON_LOCATION_DELIVERY_TAG = 'On-location Delivery';

// Cloudflare Stream
const STREAM = 'https://customer-8tlh0ntb488ziae5.cloudflarestream.com';

export const STREAM_BANDWIDTH_HINT = 10;

function streamIframe(id) {
  return `${STREAM}/${id}/iframe`;
}

export function streamHls(id, bandwidthHint = STREAM_BANDWIDTH_HINT) {
  return `${STREAM}/${id}/manifest/video.m3u8?clientBandwidthHint=${bandwidthHint}`;
}

/** Convert an iframe embed URL to HLS with bandwidth hint */
export function hlsSrcFromVideoSrc(videoSrc) {
  if (!videoSrc) return null;
  const match = videoSrc.match(/cloudflarestream\.com\/([a-f0-9]+)\/iframe/i);
  if (!match) return null;
  return streamHls(match[1]);
}

// Pick a frame past intro slates — use seconds only (percentages don't work on Stream thumbnails)
function streamPoster(id, time = '15s') {
  return `${STREAM}/${id}/thumbnails/thumbnail.jpg?time=${time}&height=480&v=3`;
}

export const CONGRESS_COVERAGE_VIDEO = streamIframe('ca19a9bd5259720ef3e445c0d2544b93');

export const CONGRESS_COVERAGE_POSTER = streamPoster('ca19a9bd5259720ef3e445c0d2544b93', '5s');

export const FIRESIDE_VIDEO = streamIframe('e00ed66486b90490060d94e35cccee41');

export const FIRESIDE_POSTER = streamPoster('e00ed66486b90490060d94e35cccee41', '15s');

const ROBOROCK_VIDEO = streamIframe('14a19fd06d2256322e3166e43c96cd18');

const ROBOROCK_POSTER = streamPoster('14a19fd06d2256322e3166e43c96cd18', '12s');

const ATTD_VIDEO = streamIframe('fa09cc35e3414d48b2096cd34ebbb00d');

export const ATTD_2026_VIDEO = ATTD_VIDEO;

const ATTD_POSTER = streamPoster('fa09cc35e3414d48b2096cd34ebbb00d', '39s');

export const ATTD_2026_POSTER = ATTD_POSTER;

const ATTD_2025_VIDEO = streamIframe('f60e500bac852ec0b17dc85a8ae0b58c');

const ATTD_2025_POSTER = streamPoster('f60e500bac852ec0b17dc85a8ae0b58c', '15s');

const ADPD_VIDEO = streamIframe('14f1e81045408682fb2666b6bd12d8ad');

const ADPD_POSTER = streamPoster('14f1e81045408682fb2666b6bd12d8ad', '5s');

const ADPD_FULL_VIDEO = streamIframe('55341d02df5f25651f3c35c9bd53deb4');

const ADPD_FULL_POSTER = streamPoster('55341d02df5f25651f3c35c9bd53deb4', '30s');

const WEB3_VIDEO = streamIframe('050117e76523b024a6dc7685cac92d01');

const INNOVATION_VIDEO = streamIframe('288e1540041911bf09765ce980619435');

const PRICING_VIDEO = streamIframe('e5a092fb5568b96d57623d43b70b9b7e');

const WEB3_POSTER = streamPoster('050117e76523b024a6dc7685cac92d01', '10s');

const WAVES_VIDEO = streamIframe('a94b4ab7fbb649afe400889f3572fec8');

const WAVES_POSTER = streamPoster('a94b4ab7fbb649afe400889f3572fec8', '20s');

const DUBAI_BOOTH_VIDEO = streamIframe('54a6be525739856de5f4bcf80019d514');

export const DUBAI_LISBON_VIDEO = DUBAI_BOOTH_VIDEO;

const DUBAI_BOOTH_POSTER = streamPoster('54a6be525739856de5f4bcf80019d514', '10s');

export const DUBAI_LISBON_POSTER = DUBAI_BOOTH_POSTER;

const DUBAI_LTW_VIDEO = streamIframe('a75f921947fdf44efd2bf8a23baa2076');

export { DUBAI_LTW_VIDEO };

const DUBAI_LTW_POSTER = streamPoster('a75f921947fdf44efd2bf8a23baa2076', '10s');

export { DUBAI_LTW_POSTER };

const KENES_VIDEO = streamIframe('c6d8c2c9dd2435fb1005a9929310c93f');

const KENES_POSTER = streamPoster('c6d8c2c9dd2435fb1005a9929310c93f', '15s');

const KENES_RECRUIT_VIDEO = streamIframe('0fc3e12ffd20954573e2635b91e3b35b');

const KENES_RECRUIT_POSTER = streamPoster('0fc3e12ffd20954573e2635b91e3b35b', '8s');

const MEDIA_PIONEER_VIDEO = streamIframe('cc3998e0ea1ff6f7d9f1a10b53c1c858');

const MEDIA_PIONEER_POSTER = streamPoster('cc3998e0ea1ff6f7d9f1a10b53c1c858', '10s');

const ESTS_VIDEO = streamIframe('811382d6947a410361268a1dcc1f37a9');

const ESTS_POSTER = streamPoster('811382d6947a410361268a1dcc1f37a9', '8s');

const STEPAC_VIDEO = streamIframe('00f2cec75a768f1a707c5b82ac997491');

const STEPAC_POSTER = streamPoster('00f2cec75a768f1a707c5b82ac997491', '12s');

const RAVENDB_VIDEO = streamIframe('01fc824146d8a6d8e0a836b7a8166915');

const RAVENDB_POSTER = streamPoster('01fc824146d8a6d8e0a836b7a8166915', '10s');

const SIMUL_VIDEO = streamIframe('b8ce190268f6b564505a78247d0bf28a');

const SIMUL_POSTER = streamPoster('b8ce190268f6b564505a78247d0bf28a', '15s');

const FB_DMEXCO_VIDEO = streamIframe('a47811573e413c9f1e02e468401402d7');

const FB_DMEXCO_POSTER = streamPoster('a47811573e413c9f1e02e468401402d7', '10s');

const ESPGHAN_2025_ONSITE_VIDEO = streamIframe('fac5922b4471880cf82854437e4537ab');

const ESPGHAN_2025_ONSITE_POSTER = streamPoster('fac5922b4471880cf82854437e4537ab', '5s');

const ESPGHAN_2026_HIGHLIGHTS_VIDEO = streamIframe('7fb5c93be0fe8d5b4437334ce7251cf9');

const WSAVA_2026_VIDEO = streamIframe('22ca798771c79182d6f1a8173027cf98');

const G4I_2026_VIDEO = streamIframe('8fbf754866574a6a2f512152cbd1340b');

const ADPD_2026_DAY1_VIDEO = streamIframe('37585a0ab26c0567a09831f4f34169a7');

const PIONEER_MEDIA_COMMERZBANK_VIDEO = streamIframe('7eb69ed740a9194bbdbe5a8c45941f04');

const ESPGHAN_2023_ONSITE_VIDEO = streamIframe('e96fd823b6e5b42e1936dcd4f66e466d');

const ESPGHAN_2023_ONSITE_POSTER = streamPoster('e96fd823b6e5b42e1936dcd4f66e466d', '5s');

export const PORTFOLIO_ITEMS = [
  // ── Selected Work (inMix: true) ────────────────────────────────────────────
  {
    id: 11,
    slug: 'dubai-booth-websummit',
    title: 'Dubai Booth @ WebSummit',
    categories: ['Booth & Activation'],
    inMix: true, mixOrder: 5,
    videoSrc: DUBAI_BOOTH_VIDEO,
    posterSrc: '/images/work/dubai-booth-websummit.webp',
    posterSrcVertical: '/images/work/dubai-booth-websummit-vertical.webp',
  },
  {
    id: 20,
    slug: 'axel-springer-hy-web3-summit',
    title: 'Axel Springer/HY Summit Series',
    categories: ['Small Events'],
    inMix: true, mixOrder: 2,
    badge: 'Series',
    videoSrc: INNOVATION_VIDEO,
    posterSrc: '/images/work/axel-springer-hy-web3-summit.webp',
    posterSrcVertical: '/images/work/axel-springer-hy-web3-summit-vertical.webp',
    campaignSlug: 'hy-summits',
  },
  {
    id: 21,
    slug: 'waves-audio-live-campaigns',
    title: 'Waves Audio European Campaigns',
    categories: ['Brand & Live'],
    inMix: true, mixOrder: 1,
    badge: 'Campaign',
    videoSrc: WAVES_VIDEO,
    posterSrc: '/images/work/waves-audio-pitbull-2025.webp',
    posterSrcVertical: '/images/work/waves-audio-pitbull-2025-vertical.webp',
    campaign: {
      role: 'Filmed and edited most of the European campaign content',
      years: '2025-2026',
      intro:
        "I've always been a massive music fan, so when Waves asked me to come film for them, I jumped at it. From artists I genuinely listen to, to ones playing stadiums on a world tour, it's a joy to be in the room for any of it. We've been filming the European legs of Waves' LV1 Classic and Livebox launches across 2025 and 2026. Four cities, behind-the-scenes films, the consoles in real touring use with the engineers who actually run them. Every show shakes out the same way. One chance, no retakes. A FOH engineer mid-show can't stop to direct you, and a live console isn't going to wait while you set up. So we work around the working surface, stay out of the mix, and get Waves footage they can actually use for the campaign. What you don't see is the rest of it. Running between drunk crowds, the occasional fight spilling past the lens, security shoving through mid-shot. Navigating bands, managers, and egos that flip from 'no cameras' to 'we want more shots of the artist!' inside an hour. Most people wouldn't believe half of what goes into two clean minutes of console footage at a sold-out show. So we move quiet, shoot fast, and stay on the good side of anyone who can shut us down.",
      outcome:
        'Launched the LV1 Classic console and Waves Livebox across Waves\' marketing channels.',
      products: [
        {
          name: 'European campaign',
          shoots: [
            {
              artist: 'Pitbull',
              engineer: 'Will Madera (FOH vocals) · LV1 Classic',
              city: 'Berlin',
              year: '2025',
              videoSrc: WAVES_VIDEO,
              posterSrc: '/images/work/waves-audio-pitbull-2025.webp',
              posterSrcVertical: '/images/work/waves-audio-pitbull-2025-vertical.webp',
            },
            {
              artist: "Ken 'Pooch' Van Druten",
              engineer: 'Livebox',
              city: 'Amsterdam',
              year: '',
              youtubeId: 'UQKFA1G7O4M',
              videoSrc: '',
              posterSrc: '',
              posterSrcVertical: '',
            },
            {
              artist: 'Andrew Peters',
              engineer: 'with Queensrÿche · LV1 Classic',
              city: 'Berlin',
              year: '',
              youtubeId: 'C9ThizRgsvs',
              videoSrc: '',
              posterSrc: '',
              posterSrcVertical: '',
            },
            {
              artist: 'Don Toliver',
              engineer: 'John Buitrago + Dannis Barnes · LV1 Classic',
              city: 'Hamburg',
              year: '2025',
              youtubeId: 'bOn67odUHwg',
              videoSrc: '',
              posterSrc: '',
              posterSrcVertical: '',
            },
          ],
        },
      ],
      editCredits:
        "Also edited for Waves: the LV1 80-channel update launch film featuring Ken 'Pooch' Van Druten, the Kevin 'Tater' McCarthy video, Lu Diaz's '6 Mixing Mistakes' (Jay Z, Beyoncé), and a second Pitbull / Will Madera LV1 Classic film.",
    },
  },
  {
    id: 40,
    slug: 'hy-summits',
    title: 'HY — summits & innovation sessions',
    // Campaign-only page: no categories so it never appears as a browse card
    // in the Netflix rows. Routed at /work/hy-summits via the existing
    // HY Web3 card's campaignSlug field.
    categories: [],
    inMix: false,
    videoSrc: WEB3_VIDEO,
    posterSrc: '/images/work/axel-springer-hy-web3-summit.webp',
    posterSrcVertical: '/images/work/axel-springer-hy-web3-summit-vertical.webp',
    campaign: {
      role: 'Filming + editing',
      years: 'Since May 2017',
      intro:
        "I've been filming for HY since May 2017. It started with their innovation courses, Audi execs coming to Berlin to meet startups, then a highlight film for Helaba. For the past five years, though, the bulk of the work has been their summits. What used to be one summit eventually became three: innovation, Web3, and pricing. High-powered meetings don't look exciting on camera by default. A room of executives talking is just a room of executives talking. The job is to find the energy that's actually in the room and get it onto the screen, with pacing, camera work, and an edit that matches the seriousness of the conversation without flattening it.",
      outcome: '',
      products: [
        {
          name: 'Summits',
          shoots: [
            { artist: 'Innovation Summit', engineer: '', city: '', year: '', character: 'Edgy by request. Punchier cuts, more attitude, built for a room that pitches.', videoSrc: INNOVATION_VIDEO, posterSrc: '/images/work/hy-innovation-summit.webp', posterSrcVertical: '/images/work/hy-innovation-summit-vertical.webp' },
            { artist: 'Web3 Summit', engineer: '', city: '', year: '', character: 'Full throttle. Dense speaker stacks, split screens.', videoSrc: WEB3_VIDEO, posterSrc: '/images/work/axel-springer-hy-web3-summit.webp', posterSrcVertical: '/images/work/axel-springer-hy-web3-summit-vertical.webp' },
            { artist: 'Pricing Summit', engineer: '', city: '', year: '', character: 'The calmest of the three. A restrained edit for a measured, analytical room.', videoSrc: PRICING_VIDEO, posterSrc: '', posterSrcVertical: '' },
          ],
        },
      ],
      editCredits: '',
    },
  },
  {
    id: 25,
    slug: 'kenes-group-brand',
    title: 'Kenes Group — Brand Video',
    categories: ['Brand & Live'],
    inMix: true, mixOrder: 7,
    videoSrc: KENES_VIDEO,
    posterSrc: '/images/work/kenes-group-brand.webp',
    posterSrcVertical: '/images/work/kenes-group-brand-vertical.webp',
  },
  {
    id: 26,
    slug: 'ests-2026-promo',
    title: 'ESTS 2026 — Promo',
    categories: ['Small Events'],
    inMix: true, mixOrder: 13,
    videoSrc: ESTS_VIDEO,
    posterSrc: '/images/work/ests-2026-promo-f.webp',
    posterSrcVertical: '/images/work/ests-2026-promo-vertical.webp',
  },
  {
    id: 16,
    slug: 'attd-2026',
    title: 'ATTD 2026 — Highlights Video',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: true, mixOrder: 8,
    videoSrc: ATTD_VIDEO,
    posterSrc: '/images/work/attd-2026.webp',
    posterSrcVertical: '/images/work/attd-2026-vertical.webp',
  },
  {
    id: 29,
    slug: 'kenes-group-recruitment',
    title: 'Kenes Group — Recruitment Video',
    categories: ['Brand & Live'],
    inMix: true, mixOrder: 3,
    videoSrc: KENES_RECRUIT_VIDEO,
    posterSrc: '/images/work/kenes-group-recruitment.webp',
    posterSrcVertical: '/images/work/kenes-group-recruitment-vertical.webp',
  },
  {
    id: 9,
    slug: 'cylus-fireside-chat-innotrans-berlin',
    title: 'Cylus — Fireside Chat · InnoTrans Berlin',
    categories: ['Booth & Activation'],
    boothOrder: 2, inMix: false,
    videoSrc: FIRESIDE_VIDEO, posterSrc: FIRESIDE_POSTER,
  },
  {
    id: 24,
    slug: 'media-pioneer',
    title: 'Media Pioneer',
    categories: ['On-location Delivery'],
    inMix: true, mixOrder: 10,
    videoSrc: MEDIA_PIONEER_VIDEO, posterSrc: MEDIA_PIONEER_POSTER,
  },
  {
    id: 33,
    slug: 'g4i-2026-promo',
    title: 'G4I 2026 — Promo',
    categories: ['Small Events'],
    inMix: true, mixOrder: 12,
    videoSrc: G4I_2026_VIDEO,
    posterSrc: '/images/work/g4i-2026-promo-f.webp',
    posterSrcVertical: '/images/work/g4i-2026-promo-vertical.webp',
  },
  {
    id: 35,
    slug: 'pioneer-media-commerzbank',
    title: 'Pioneer Media — Commerzbank Event',
    categories: ['Small Events'],
    inMix: false,
    videoSrc: PIONEER_MEDIA_COMMERZBANK_VIDEO,
    posterSrc: '/images/work/pioneer-media-commerzbank-f.webp',
    posterSrcVertical: '/images/work/pioneer-media-commerzbank-vertical.webp',
  },

  // ── Promos and Highlights ───────────────────────────────────────────────────
  {
    id: 18,
    slug: 'adpd-2026-highlights',
    title: 'AD/PD 2026 — Highlights Reel',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: false,
    videoSrc: ADPD_FULL_VIDEO,
    posterSrc: '/images/work/adpd-2026-highlights.webp',
    posterSrcVertical: '/images/work/adpd-2026-highlights-vertical.webp',
  },
  {
    id: 33,
    slug: 'espghan-2025',
    title: 'ESPGHAN 2025',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: false,
    videoSrc: ESPGHAN_2025_ONSITE_VIDEO, posterSrc: ESPGHAN_2025_ONSITE_POSTER,
  },
  {
    id: 37,
    slug: 'attd-2025',
    title: 'ATTD 2025 — Highlights Video',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: false,
    videoSrc: ATTD_2025_VIDEO,
    posterSrc: '/images/work/attd-2025.webp',
    posterSrcVertical: '/images/work/attd-2025-vertical.webp',
  },
  {
    id: 36,
    slug: 'espghan-2023',
    title: 'ESPGHAN 2023',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: false,
    videoSrc: ESPGHAN_2023_ONSITE_VIDEO, posterSrc: ESPGHAN_2023_ONSITE_POSTER,
  },
  {
    id: 17,
    slug: 'adpd-2026-day2',
    title: 'AD/PD 2026 — Day 2 Highlight Video',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: true, mixOrder: 9,
    videoSrc: ADPD_VIDEO,
    posterSrc: '/images/work/adpd-2026-day2.webp',
    posterSrcVertical: '/images/work/adpd-2026-day2-vertical.webp',
  },
  {
    id: 34,
    slug: 'adpd-2026-day1',
    title: 'AD/PD 2026 — Day 1 Reel',
    categories: ['Promos and Highlights', 'On-location Delivery'],
    inMix: false,
    videoSrc: ADPD_2026_DAY1_VIDEO,
    posterSrc: '/images/work/adpd-2026-day1-f.webp',
    posterSrcVertical: '/images/work/adpd-2026-day1-vertical.webp',
  },

  // ── Promos and Highlights (cont.) ───────────────────────────────────────────
  {
    id: 30,
    slug: 'espghan-2026-highlights',
    title: 'ESPGHAN 2026 — Highlights',
    categories: ['Promos and Highlights'],
    inMix: true, mixOrder: 4,
    videoSrc: ESPGHAN_2026_HIGHLIGHTS_VIDEO,
    posterSrc: '/images/work/espghan-2026-highlights-f.webp',
    posterSrcVertical: '/images/work/espghan-2026-highlights-vertical.webp',
  },
  {
    id: 32,
    slug: 'wsava-2026-promo',
    title: 'WSAVA 2026 — Promo',
    categories: ['Promos and Highlights'],
    inMix: true, mixOrder: 11,
    videoSrc: WSAVA_2026_VIDEO,
    posterSrc: '/images/work/wsava-2026-promo-f.webp',
    posterSrcVertical: '/images/work/wsava-2026-promo-vertical.webp',
  },

  // ── Brand & Live ───────────────────────────────────────────────────────────
  {
    id: 31,
    slug: 'simul-europe',
    title: 'Simul Europe — Economic Conference, Greece',
    categories: ['Brand & Live', 'Small Events'],
    inMix: false,
    videoSrc: SIMUL_VIDEO,
    posterSrc: '/images/work/simul-europe-f.webp',
    posterSrcVertical: '/images/work/simul-europe-vertical.webp',
  },
  // ── Booth & Activation ─────────────────────────────────────────────────────
  {
    id: 38,
    slug: 'dubai-booth-london-tech-week',
    title: 'Dubai Booth @ London Tech Week',
    categories: ['Booth & Activation'],
    boothOrder: 1, inMix: false,
    videoSrc: DUBAI_LTW_VIDEO,
    posterSrc: '/images/work/dubai-booth-london-tech-week.webp',
    posterSrcVertical: '/images/work/dubai-booth-london-tech-week-vertical.webp',
  },
  {
    id: 39,
    slug: 'ravendb-wearedevelopers-berlin',
    title: 'RavenDB @ WeAreDevelopers Berlin',
    categories: ['Booth & Activation'],
    boothOrder: 3, inMix: false,
    videoSrc: RAVENDB_VIDEO,
    posterSrc: '/images/work/ravendb-wearedevelopers-berlin.webp',
    posterSrcVertical: '/images/work/ravendb-wearedevelopers-berlin-vertical.webp',
  },
  {
    id: 32,
    slug: 'meta-dmexco',
    title: 'Meta @ DMEXCO',
    categories: ['Booth & Activation'],
    boothOrder: 4, inMix: false,
    videoSrc: FB_DMEXCO_VIDEO, posterSrc: FB_DMEXCO_POSTER,
  },
  {
    id: 15,
    slug: 'roborock-ifa-berlin',
    title: 'ROBOROCK — IFA Berlin',
    categories: ['Booth & Activation'],
    boothOrder: 5, inMix: false,
    videoSrc: ROBOROCK_VIDEO, posterSrc: ROBOROCK_POSTER,
  },
  {
    id: 14,
    slug: 'stepac-fruit-logistica-berlin',
    title: 'STEpac — Fruit Logistica, Berlin',
    categories: ['Booth & Activation'],
    boothOrder: 6, inMix: false,
    videoSrc: STEPAC_VIDEO, posterSrc: STEPAC_POSTER,
  },

  // ── Brand & Live (cont.) ───────────────────────────────────────────────────
  {
    id: 41,
    slug: 'cornelsen-innovation-awards',
    title: 'Cornelsen Innovation Award Clips',
    categories: ['Brand & Live'],
    inMix: false,
    badge: 'Series',
    posterSrc: '/images/work/cornelsen-award-f.webp',
    posterSrcVertical: '/images/work/cornelsen-award-v2-vertical.webp',
    videoSrc: streamIframe('8aac8f57c4dd98dfc5d79b9b6d318ed2'),
    campaign: {
      role: 'Filming + editing',
      years: 'Ongoing',
      layout: 'rows',
      intro:
        "The skill isn't pointing a camera at a school. It's getting a school to let you point a camera at the part that actually matters. For several years now we've been filming the winner films for two Cornelsen school awards: the Zukunftspreis, which honors innovative teaching and school leadership, and fair@school, a prize run with the Federal Anti-Discrimination Agency for school projects that stand up for diversity and against discrimination. Each film features a school that's doing something genuinely new, and the job is to show the place and explain, in a few minutes, what makes it worth recognizing. It's a different kind of brief from a conference highlight reel. Less pace, more story. You're not capturing the energy of a room, you're trying to capture the spirit of a place and the people who made it different. The hard part is rarely the filming. It's earning the trust of kids who don't want to be on camera, or don't want to be properly interviewed. Sometimes the reason for the award is quietly hidden, a small group of kids trying something the wider community hasn't caught up with yet, and the film has to honor that without exposing anyone. Sometimes it's a sensitive topic taught in a way that doesn't take a side but doesn't pretend the thing doesn't exist either, like how you teach kids about war.",
      outcome: '',
      products: [
        {
          name: 'Zukunftspreis',
          shoots: [
            { artist: 'School in Radibor', engineer: '', city: 'Radibor', year: '', character: '', youtubeId: 'Hw0WfXQSGiQ', videoSrc: '', posterSrc: '/images/work/cornelsen-zukunftspreis-radibor.webp', posterSrcVertical: '' },
            { artist: 'School in Waren', engineer: '', city: 'Waren', year: '', character: '', videoSrc: streamIframe('8aac8f57c4dd98dfc5d79b9b6d318ed2'), posterSrc: streamPoster('8aac8f57c4dd98dfc5d79b9b6d318ed2', '25s'), posterSrcVertical: '' },
            { artist: 'School in Hannover', engineer: '', city: 'Hannover', year: '', character: '', videoSrc: streamIframe('15dc76216134c9a744bfcf380360d646'), posterSrc: streamPoster('15dc76216134c9a744bfcf380360d646', '25s'), posterSrcVertical: '' },
            { artist: 'School in Solingen', engineer: '', city: 'Solingen', year: '', character: '', videoSrc: streamIframe('6234c2c2f3f48388d62dc8907dddf552'), posterSrc: streamPoster('6234c2c2f3f48388d62dc8907dddf552', '25s'), posterSrcVertical: '' },
            { artist: 'School in Rangsdorf', engineer: '', city: 'Rangsdorf', year: '', character: '', videoSrc: streamIframe('8deb1b89e4ba72532e4ee85735026d22'), posterSrc: streamPoster('8deb1b89e4ba72532e4ee85735026d22', '25s'), posterSrcVertical: '' },
          ],
        },
        {
          name: 'fair@school',
          shoots: [
            { artist: 'School in Spremberg', engineer: '', city: 'Spremberg', year: '', character: '', videoSrc: streamIframe('7d13e7981082a2cf618097dea6816980'), posterSrc: streamPoster('7d13e7981082a2cf618097dea6816980', '30s'), posterSrcVertical: '' },
            { artist: 'School in Scharnebeck', engineer: '', city: 'Scharnebeck', year: '', character: '', videoSrc: streamIframe('ce8861acace4e410f4368705a1d9fc50'), posterSrc: streamPoster('ce8861acace4e410f4368705a1d9fc50', '90s'), posterSrcVertical: '' },
            { artist: 'School in Neuss', engineer: '', city: 'Neuss', year: '', character: '', videoSrc: streamIframe('c042cb89f1c798fe0daf1c93f6c55890'), posterSrc: streamPoster('c042cb89f1c798fe0daf1c93f6c55890', '60s'), posterSrcVertical: '' },
          ],
        },
      ],
      editCredits: '',
    },
  },
];
